import styled from 'styled-components';
import { Typography } from '../../typography';

export const DropdownValue = styled(Typography.Medium).attrs(() => ({
  className: 'ap-dropdown-value'
}))`
    width: calc(100% - 20px);
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `;
